// extracted by mini-css-extract-plugin
module.exports = {"linkContainer":"Link_linkContainer__7oEQc","linkPadding":"Link_linkPadding__08yxq","extraPadding":"Link_extraPadding___OU2J","linkLabel":"Link_linkLabel__Y52YV"};